import { render, staticRenderFns } from "./QuestionChoice.vue?vue&type=template&id=5e58ab45&"
import script from "./QuestionChoice.vue?vue&type=script&lang=js&"
export * from "./QuestionChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "QuestionChoice.vue"
export default component.exports